(function () {
  var popup = document.getElementById('redirect-popup');
  if (!popup) return;

  var rules = [];
  try {
    rules = JSON.parse(popup.dataset.rules || '[]');
  } catch (e) {
    return;
  }

  if (!rules.length) return;

  var currentCountry = (window.country_iso_code || '').toUpperCase();
  if (!currentCountry) return;

  var matched = null;
  for (var i = 0; i < rules.length; i++) {
    if (rules[i].country === currentCountry) {
      matched = rules[i];
      break;
    }
  }
  if (!matched) return;

  var sessionKey = 'redirect_popup_dismissed_' + currentCountry;
  if (sessionStorage.getItem(sessionKey)) return;

  // Populate content dynamically
  document.getElementById('redirect-popup-heading').textContent = matched.heading || '';
  document.getElementById('redirect-popup-body').textContent = matched.body || '';

  var stayBtn = document.getElementById('redirect-popup-stay-btn');
  var goBtn = document.getElementById('redirect-popup-go-btn');

  stayBtn.textContent = matched.stayLabel || 'Stay';
  goBtn.textContent = matched.goLabel || 'Go';

  function showPopup() {
    popup.style.display = 'flex';
  }

  function dismissPopup() {
    popup.style.display = 'none';
    sessionStorage.setItem(sessionKey, '1');
  }

  stayBtn.addEventListener('click', dismissPopup);

  goBtn.addEventListener('click', function () {
    window.location.href = matched.url;
  });

  popup.addEventListener('click', function (e) {
    if (e.target === popup) dismissPopup();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', showPopup);
  } else {
    showPopup();
  }
})();
